import { render } from "./Visualization3D.vue?vue&type=template&id=f6a228e2"
import script from "./Visualization3D.vue?vue&type=script&lang=js"
export * from "./Visualization3D.vue?vue&type=script&lang=js"

import "./Visualization3D.vue?vue&type=style&index=0&id=f6a228e2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__